import React, { useState } from 'react'
import { ArrowCaret } from '@fs/zion-icon'
import { Expander, ExpanderContent, Paragraph, Separator, Button, Skeleton } from '@fs/zion-ui'
import DOMPurify from 'dompurify'
import { useTranslation } from 'react-i18next'

const ArrowUp = () => <ArrowCaret direction="up" />
const ArrowDown = () => <ArrowCaret direction="down" />

function DefinitionLoading() {
  return (
    <div data-testid="surname-definition-loading">
      <Skeleton.Paragraph lineCount={2} />
      <Separator size="nano" />
      <Skeleton.Paragraph lineCount={2} />
    </div>
  )
}

export default function SurnameDefinition({ definition, isLoading }) {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)
  const [doesExpand, setDoesExpand] = useState(false)

  if (isLoading) {
    return <DefinitionLoading />
  }

  if (!definition) {
    return null
  }

  // replace all <p> tags and set the definition as an array of strings by paragraph
  const sanitizedDefinition = definition
    .split(/<\/?p>/)
    .filter(Boolean)
    .map((para, index) => ({ id: `para-${index}`, content: para.trim() }))

  return (
    <>
      <Separator />
      <Expander open={expanded} setOpen={setExpanded}>
        <ExpanderContent collapsedHeight={116} setDoesExpand={setDoesExpand} data-testid="surname-definition-content">
          {sanitizedDefinition.map((para) => (
            <React.Fragment key={para.id}>
              <Paragraph
                size="sm"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(para.content) }}
                data-testid="surname-definition"
              />
            </React.Fragment>
          ))}
        </ExpanderContent>
      </Expander>
      {doesExpand && (
        <>
          <Separator size="nano" />
          <Button
            aria-expanded={!!expanded}
            data-testid="surname-definition-view-more"
            emphasis="low"
            color="gray"
            onClick={() => setExpanded(!expanded)}
            Icon={expanded ? ArrowUp : ArrowDown}
            linkName={`SurnameDefinition: ${expanded ? 'ViewMore' : 'ViewLess'}`}
          >
            {expanded
              ? t('apac.section-template.lead-section-b.show-less', 'Show Less')
              : t('apac.section-template.lead-section-b.show-more', 'Show More')}
          </Button>
        </>
      )}
    </>
  )
}
